import { useRef } from 'react'
import { FormControl } from 'baseui/form-control'
import { SIZE } from 'baseui/button'
import { Notification, KIND as NOTIFICATION_KIND } from 'baseui/notification'
import { Input } from 'baseui/input'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import SDDatePicker from '@/shared/components/SDComponents/SDDatePicker'

import useNettingUpdater from './useNettingUpdater'
import {
  ActionsRow,
  NotificationsWrapper,
  FileRow,
  FileLabel,
  FileName,
  ClearFileButton,
  Stack,
} from './styled-components'

const NettingUpdaterForm = ({ isPro = false }) => {
  const { form, result, t } = useNettingUpdater({ isPro })
  const inputRef = useRef(null)

  const hasSuccessMessage = result.message && !result.error
  const hasErrorMessage = result.error

  return (
    <div>
      <FileRow>
        <FormControl
          label={`${t('netting.label_file')}${form.acceptedExtensions ? ` (${form.acceptedExtensions})` : ''}`}
        >
          <Stack>
            <input
              ref={inputRef}
              type='file'
              accept={form.acceptedExtensions || undefined}
              onChange={form.onFileChange}
              style={{ display: 'none' }}
            />
            <FileLabel onClick={() => inputRef.current?.click()}>{t('netting.button_choose_file')}</FileLabel>
            {form.fileName && (
              <FileName>
                {form.fileName}
                <ClearFileButton
                  onClick={() => {
                    if (inputRef.current) inputRef.current.value = ''
                    form.onFileClear()
                  }}
                >
                  &times;
                </ClearFileButton>
              </FileName>
            )}
          </Stack>
        </FormControl>
      </FileRow>

      <FormControl label={t('netting.ftps.label_start_date')}>
        <SDDatePicker
          value={form.startDate ? [form.startDate] : []}
          onChange={form.onStartDateChange}
          formatString="dd/MM/yyyy"
          placeholder={t('netting.ftps.placeholder_date')}
        />
      </FormControl>

      <FormControl
        label={t('netting.ftps.label_limit')}
        caption={t('netting.ftps.caption_limit')}
      >
        <Input
          value={form.limit}
          onChange={form.onLimitChange}
          type="number"
          min={1}
          placeholder={t('netting.ftps.placeholder_limit')}
        />
      </FormControl>

      <ActionsRow>
        <SDButton
          onClick={form.onSubmit}
          isLoading={form.isSubmitting}
          disabled={!form.isValid || form.isSubmitting}
          size={SIZE.compact}
        >
          {t('netting.button_submit')}
        </SDButton>
      </ActionsRow>

      {hasSuccessMessage && (
        <NotificationsWrapper>
          <Notification
            kind={NOTIFICATION_KIND.positive}
            overrides={{ Body: { style: { width: 'auto', marginLeft: 0 } } }}
          >
            {String(result.message)}
          </Notification>
        </NotificationsWrapper>
      )}

      {hasErrorMessage && (
        <NotificationsWrapper>
          <Notification
            kind={NOTIFICATION_KIND.negative}
            overrides={{ Body: { style: { width: 'auto', marginLeft: 0 } } }}
          >
            {String(result.error)}
          </Notification>
        </NotificationsWrapper>
      )}
    </div>
  )
}

export default NettingUpdaterForm
